import { Archive } from "lucide-react";
import { Badge } from "./badge";

/**
 * Selo "Arquivado" (status do produto, nao da publicacao). Fonte unica para a
 * ficha, a lista do canal e a busca. `title` leva o "por quem/quando" quando
 * a tela ja tem o dado.
 */
export function ArchivedBadge({ title }: { title?: string }): JSX.Element {
  return (
    <Badge
      variant="secondary"
      title={title ?? "Produto arquivado: fora da operação da vitrine"}
      style={{ background: "var(--color-soft)", color: "var(--color-ink-2)" }}
    >
      <Archive className="icon" style={{ width: "0.875em", height: "0.875em" }} aria-hidden />
      Arquivado
    </Badge>
  );
}
